import axios from 'axios';
import { formDataToJson } from '../../../scripts/utils/formDataToJson';

const form = document.getElementById('become-member-form');
if (!form) return;

const successMessage = form.querySelector('#become-member__success');
const errorMessage = form.querySelector('#become-member__error');

form.addEventListener('submit', async (e) => {
  e.preventDefault();
  const formData = new FormData(form);

  // return if the form is empty
  if (formData.entries().next().done) return;

  const jsonData = formDataToJson(formData);
  if (!jsonData) return;

  const email = jsonData.email;
  const birthDate = jsonData.birthDate;
  const agreement1 = jsonData.agreement1;

  if (!email || !birthDate || !agreement1) {
    errorMessage.classList.remove('hidden');
    return;
  }

  try {
    const url = 'https://intersportapi.netlify.app/.netlify/functions/createMember';

    await axios.post(url, jsonData);

    successMessage.classList.remove('hidden');
    errorMessage.classList.add('hidden');
    setTimeout(() => {
      window.location.href = '/account?view=loyalty';
    }, 1500);
  } catch (error) {
    console.log('🚀 ~ error:', error);
    successMessage.classList.add('hidden');
    errorMessage.classList.remove('hidden');
  }
});
